export default {
  pt: {
    pageTitle: "Contratar",
    mainTitle: "A bicicleta está com você?",
    description: "Você deve estar com a bicicleta para enviar as evidências de vídeo e foto.",
    deferrableDescription:
      "Você pode concluir a contratação agora e enviar a inspeção depois. A cobertura será liberada após o envio e validação das informações da bicicleta.",
    yesButton: "SIM",
    noButton: "NÃO",
    inspectNowButton: "FAZER INSPEÇÃO AGORA",
    sendLaterButton: "ENVIAR DEPOIS",
    toastTitle: "Volte depois",
    toastDescription: "Espere para retomar quando a bike estiver junto com você!",
    deferredErrorTitle: "Não foi possível continuar",
    deferredErrorDescription:
      "Para esse seguro, é necessário estar com a bicicleta. Tente novamente quando estiver com ela.",
  },

  en: {
    pageTitle: "Contract",
    mainTitle: "Is the bicycle with you?",
    description: "You must have the bicycle to send video and photo evidence.",
    deferrableDescription:
      "You can complete the purchase now and submit the inspection later. Coverage will be released after the bicycle information is submitted and validated.",
    yesButton: "YES",
    noButton: "NO",
    inspectNowButton: "INSPECT NOW",
    sendLaterButton: "SEND LATER",
    toastTitle: "Come back later",
    toastDescription: "Wait to resume when the bike is with you!",
    deferredErrorTitle: "Can't continue",
    deferredErrorDescription:
      "For this plan, you must have the bicycle with you. Please try again later.",
  },
};
